import {
  WIZARD_ANSWER,
  WIZARD_PREVIOUS,
  WIZARD_NEXT
} from '../actions/Wizard.actions'

export const wizardReducer = (state, action) => {
  switch (action.type) {
    case WIZARD_ANSWER:
      return {
        ...state,
        previous: state.current,
        current: action.payload,
        history: {
          ...state.history,
          [action.payload]: action.payload
        }
      }
    case WIZARD_PREVIOUS:
      return {
        ...state,
        previous: action.payload,
        current: state.previous,
        next: state.current
      }
    case WIZARD_NEXT:
      return {
        ...state,
        previous: state.current,
        current: state.next,
        next: action.payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/js/quiz/state/reducers/Wizard.reducer.jsx